import ListCreateButton from 'components/buttons/ListCreateButton';
import PageHeader from 'components/PageHeader';
import PaddedLayout from 'layout/MainLayout/PaddedLayout';
import { useNavigateWithReturnState } from 'utils/useNavigateWithReturnState';
import OfficesTableWithFilters from './OfficesTable';

// ==============================|| OFFICES LIST PAGE ||============================== //

const OfficesListPage = () => {
    const navigateWithReturn = useNavigateWithReturnState();

    return (
        <PaddedLayout className="overflow-hidden">
            <div className="flex h-full flex-col gap-4">
                <PageHeader
                    hostsList
                    titleId={'offices.offices'}
                    showBreadcrumb
                    buttons={
                        <div>
                            <ListCreateButton
                                permissions={['CREATE.OFFICES']}
                                variant="contained"
                                color="secondary"
                                size="small"
                                onClick={() => navigateWithReturn(`/office/new`)}
                                labelId="offices.add-new-office"
                                newLabelId="new-entity.office"
                            />
                        </div>
                    }
                />
                <OfficesTableWithFilters />
            </div>
        </PaddedLayout>
    );
};

export default OfficesListPage;
